import { Box } from '@mui/material';
import { AlertBoxMsg } from '@qrios/frontend-library';
import { DeleteForeverOutlined } from '@mui/icons-material';

import { DialogError } from '../../../business-error';
import locales from '../../../../../constants/locales';
import { DialogActionButtons, DialogDescription } from '../../../dialog';

import { CanceledReport } from './interfaces';

interface Props {
  loading: boolean;
  report: CanceledReport | undefined;
  error: DialogError;
  handleCancelReport: () => void;
  handleCloseCancelDialog: () => void;
}

const CancelReportDialog = ({ loading, report, error, handleCancelReport, handleCloseCancelDialog }: Props) => {
  const actions = {
    primary: {
      type: 'button' as const,
      handler: handleCancelReport,
      text: locales.button.title.cancelReportGeneration
    },
    secondary: {
      type: 'button' as const,
      handler: handleCloseCancelDialog,
      text: locales.button.title.close
    }
  };

  return report ? (
    <Box minHeight="200px" display="flex" flexDirection="column" justifyContent="space-between">
      <DialogDescription icon={DeleteForeverOutlined}>
        You want to cancel pending <b>{report.name}</b> report. This operation cannot be undone. Click{' '}
        <b>Cancel report generation</b> to confirm.
      </DialogDescription>
      {error ? (
        <Box pt={2}>
          <AlertBoxMsg severity={error.severity}>{error.message}</AlertBoxMsg>
        </Box>
      ) : null}
      <DialogActionButtons actions={actions} loading={loading} danger={true} />
    </Box>
  ) : null;
};

export default CancelReportDialog;
